var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tobind"},[_c('div',{staticClass:"bind-box"},[_c('img',{attrs:{"src":require("@/assets/img/public/bind-wx.png"),"alt":""}}),_c('button',{on:{"click":function($event){return _vm.toBind()}}},[_vm._v(" 去绑定 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }